<script setup>
    import DataPrivacyBody from './DataPrivacyBody.vue';
</script>
<template>
    <div class="w-100 custom-inner-view container-privacy-body-wrapper">
        <div class="container">
            <DataPrivacyBody />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .ontainer-privacy-body-wrapper {
        background: rgb(255,255,255);
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(224,228,233,1) 100%);
    }
</style>